export class TutorialModel {
  constructor(
    public profile: boolean,
    public diet: boolean,
    public noDiet: boolean,
    public plan: boolean,
    public addFood: boolean,
    public hasFood: boolean,
    public suggestedPackage: boolean,
    public kitchen: boolean,
    public shoppingList: boolean,
    public members: boolean
  ) {}

  static fromJSON(json: TutorialJSON | string): TutorialModel {
    if (typeof json === 'string') {
      // if it's a string, parse it first
      return JSON.parse(json, TutorialModel.reviver);
    } else {
      // create an instance of the User class
      const user = Object.create(TutorialModel.prototype);
      // copy all the fields from the json object
      return Object.assign(user, json, {
        // convert fields that need converting
      });
    }
  }

  // reviver can be passed as the second parameter to JSON.parse
  // to automatically call User.fromJSON on the resulting value.
  static reviver(key: string, value: any): any {
    return key === '' ? TutorialModel.fromJSON(value) : value;
  }
}

interface TutorialJSON {
  profile: boolean;
  diet: boolean;
  noDiet: boolean;
  plan: boolean;
  addFood: boolean;
  hasFood: boolean;
  suggestedPackage: boolean;
}
